var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg314(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reverse",
    fillRule: "evenodd",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.529050, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "base",
    stroke: "#687577",
    fill: "#FFFFFF",
    d: "M21.7964618,26.8544956 C18.623063,26.8544956 16.1333246,24.2821154 15.1254255,23.053116 C12.4793848,25.036067 9.07646394,25.7250781 5.86289523,24.9285595 C2.24487562,24.082549 0.47674057,22.5928424 0.130426175,20.0943121 C-0.023759616,18.984503 -0.379042312,15.1044647 1.52327232,11.7839681 C2.75744852,9.63029954 5.17957967,6.2847283 9.71512547,2.5833037 C12.1275985,0.61408811 14.8691391,-0.277949723 17.435108,0.0758427173 C19.8175717,0.401812646 21.9051162,1.75412414 23.4714645,3.98645139 C26.5858795,8.42397036 27.8914572,11.3989183 27.976656,14.2567368 C28.0166685,15.5760735 28.0873801,17.0702454 28.145674,18.3140148 C28.2018984,19.4987042 28.24605,20.4347085 28.24605,20.8379632 C28.24605,22.0515056 26.5762213,26.814651 21.8485469,26.8569 L21.7957719,26.8569 L21.7964618,26.8544956 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.470000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hookstyle",
    transform: "scale(-1, 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hook",
    fill: "none",
    transform: "translate(-8.000000, -8.000000)",
    d: "M3.58716581,4.86252597 C3.06706263,4.62380711 2.85229747,4.03585383 3.10747439,3.54929557 C3.36265132,3.06273731 3.99114002,2.86182379 4.5112432,3.10054265 C5.46056455,3.53626565 6.39450266,4.14450585 7.31484578,4.922185 C8.2443698,5.70762188 10.0438875,7.8539425 12.8028208,11.4459993 C13.1408693,11.8861293 13.0335172,12.4992928 12.5630432,12.8155382 C12.0925692,13.1317837 11.4371322,13.0313555 11.0990837,12.5912255 C8.44101017,9.13048544 6.68104531,7.03134029 5.90861111,6.37864246 C5.12699602,5.71818688 4.35258484,5.21384081 3.58716581,4.86252597 Z"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "extracted",
    x1: 6.47095,
    y1: 7.5,
    x2: 24.47095,
    y2: 24.5,
    stroke: "none",
    strokeLinecap: "square"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg314);
export default __webpack_public_path__ + "static/media/3-14.9559714d41742636516482326ee0dc52.svg";
export { ForwardRef as ReactComponent };